// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Icon from 'vue-awesome/components/Icon';
import VeeValidate, { Validator } from 'vee-validate';
import 'vue-awesome/icons';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import VueApollo from 'vue-apollo';
import dateformat from 'dateformat';
import VueAnalytics from 'vue-analytics';

import $ from 'jquery';
import 'popper.js';
import 'bootstrap';

import App from './App';
import router from './router';

const isProd = process.env.NODE_ENV === 'production';

// --- apollo
const adminHttpLink = new HttpLink({
  // You should use an absolute URL here
  uri: `${document.location.origin}/api/admin`,
  credentials: 'same-origin',
});
const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri: `${document.location.origin}/api`,
  credentials: 'same-origin',
});

// Create the apollo client
const adminApolloClient = new ApolloClient({
  link: adminHttpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});
const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});
const apolloProvider = new VueApollo({
  clients: {
    admin: adminApolloClient,
  },
  defaultClient: apolloClient,
});

// Install the vue plugin
Vue.use(VueApollo);
// ---

// --- vee-validate
// Validator.localize('ru', ru);
Validator.localize('ru', {
  messages: {
    required: 'Это поле обязательно для заполнения',
    email: 'Некорректное значение email',
    min_value: 'Некорректное значение',
    regex: 'Некорректное значение',
  },
});

Vue.use(VeeValidate);
// ---

// --- global components and mixins
Vue.component('icon', Icon);
Vue.mixin({
  methods: {
    $_removeImmutabitity(value) {
      if (Array.isArray(value)) {
        return $.extend(true, [], value);
      }
      return $.extend(true, {}, value);
    },
    $_tryToAutofocus() {
      if (this.$refs.autofocus) {
        this.$refs.autofocus.focus();
      }
    },
    $_scrollToAnchor() {
      if (!document.location.hash) return;
      const locationHash = decodeURIComponent(document.location.hash.substr(1));
      if (!locationHash) return;
      setTimeout(() => {
        const anchorElement = document.querySelector(`[anchor="${locationHash}"]`);
        if (!anchorElement) return;
        $('html, body').animate({
          scrollTop: anchorElement.offsetTop,
        }, 500);
      }, 100);
    },
  },
  filters: {
    date(date, defaultValue) {
      return date ? dateformat(new Date(date), 'dd.mm.yyyy') : (defaultValue || '');
    },
    datetime(date, defaultValue) {
      return date ? dateformat(new Date(date), 'dd.mm.yyyy HH:MM') : (defaultValue || '');
    },
    day_of_week(date, defaultValue) {
      if (!date) {
        return defaultValue || '';
      }
      const daysOfWeek = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];
      return daysOfWeek[new Date(date).getDay()];
    },
    duration(value) {
      if (value == null) return '--:--';
      const minus = value < 0 ? '-' : '';
      const absValue = Math.abs(value);
      let minutes = Math.floor(absValue / 60);
      let seconds = absValue % 60;
      if (Number.isNaN(minutes) || Number.isNaN(seconds)) {
        return '--:--';
      }
      if (minutes < 10) minutes = `0${minutes}`;
      if (seconds < 10) seconds = `0${seconds}`;
      return `${minus}${minutes}:${seconds}`;
    },
  },
});
// ---

// --- google analytics
// https://medium.com/dailyjs/tips-tricks-for-vue-analytics-87a9d2838915
Vue.use(VueAnalytics, {
  id: 'UA-50329484-5',
  router,
  autoTracking: {
    exception: true,
  },
  debug: {
    enabled: !isProd,
    sendHitTask: isProd,
  },
});
// ---

Vue.config.productionTip = false;

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  apolloProvider,
  components: { App },
  template: '<App/>',
  methods: {
    playAudio(options) {
      this.$children[0].playAudio(options);
    },
    pauseAudio() {
      this.$children[0].pauseAudio();
    },
    hideAudioPlayer() {
      this.$children[0].hideAudioPlayer();
    },
  },
});
